<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";
  .search {
    display: flex;
    align-items: center;
    border-radius: 6px;
    border: solid 1.4px colors.get(interfaceSwGrey_10);

    &:not(:has(input:disabled)) {
      cursor: pointer;
    }
    background-color: white;

    &:has(input:disabled) {
      background-color: colors.get(interfaceDisabledGrey_5);
    }
    > input {
      flex: 1;
      border: none;
      width: 100%;
      &:focus {
        outline: none;
      }
      &:disabled {
        background-color: transparent;
      }
    }

    &:not(:has(input:disabled)) {
      &:focus-within,
      .filled {
        outline: 2px solid colors.get(primary_40);
      }
    }

    &.xsmall {
      height: utils.in_rem(32px);
      gap: utils.in_rem(8px);
      padding: utils.in_rem(8px);

      > input {
        @include mixins.body3();
      }
    }

    &.small {
      height: utils.in_rem(36px);
      gap: utils.in_rem(8px);
      padding: utils.in_rem(8px);

      > input {
        @include mixins.body2();
      }
    }

    &.large {
      height: utils.in_rem(44px);
      gap: utils.in_rem(14px);
      padding: utils.in_rem(8px) utils.in_rem(12px);
    }
  }
</style>

<script>
  import IconButton from "../IconButton.svelte";
  import IconScale from "../IconScale.svelte";

  /** @type {"xsmall" | "small" | "large"} */
  export let size = "small";

  export let style = "";

  let cls = "";
  export { cls as class };

  export let leadingIcon = "fa-magnifying-glass";

  export let placeholder = "";
  export let disabled = false;

  let keydown = () => {};
  export { keydown as onkeydown };

  /** @type {string} */
  export let value;

  let el;
  export const focus = () => !disabled && el?.focus();

  export let find = null; // find snippet

  const onkeydown = (e) => {
    if (["Enter"].includes(e.key)) {
      e.preventDefault();
      focus();
    }
    keydown(e);
  };
  const clearInput = (e) => {
    value = "";
    focus();
    e.stopPropagation();
  };

  const iconSize = size === "small" ? "small" : "medium";

  $: restProps = disabled ? { "aria-disabled": true } : { tabindex: "-1" };
</script>

<div
  on:click={focus}
  on:{focus}
  tabindex="-1"
  role="searchbox"
  on:keydown={onkeydown}
  class="search {cls} {size}"
  class:filled={value}
  {style}
  {...restProps}
>
  <IconScale class={leadingIcon} size={iconSize} />
  <input bind:this={el} bind:value {placeholder} {disabled} />
  {#if value}
    {#if find}
      {@render find()}
    {/if}
    <IconButton icon="fa-xmark" size={iconSize} onclick={clearInput} />
  {/if}
</div>
